var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptySubmissionNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 86,
    fill: "#F2FBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 53.0203V124.903C64 126.785 65.0936 128.59 67.0402 129.921C68.9868 131.252 71.627 132 74.3799 132H122.721C124.715 131.996 126.67 131.618 128.37 130.905C126.874 130.268 125.639 129.381 124.783 128.327C123.927 127.273 123.478 126.088 123.477 124.883V53L64 53.0203Z",
    fill: "#CAF0F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.977 120.883L111.982 121.133C112.041 122.379 112.534 123.582 113.396 124.643C114.091 125.498 115.01 126.24 116.093 126.838C114.73 127.268 113.239 127.497 111.72 127.5H63.3799C60.7104 127.5 58.1725 126.774 56.3223 125.509C54.4732 124.245 53.5001 122.578 53.5 120.903V49.5195L111.977 49.5V120.883Z",
    fill: "#ADE8F4",
    stroke: "#0096C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.882 60.7036H69.707V62.4445H103.882V60.7036Z",
    fill: "#00B4D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.882 65.3706H61.3828V67.1115H103.882V65.3706Z",
    fill: "#00B4D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.882 70.0229H61.3828V71.7639H103.882V70.0229Z",
    fill: "#00B4D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.882 74.6895H61.3828V76.4304H103.882V74.6895Z",
    fill: "#00B4D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.882 79.3564H61.3828V81.0974H103.882V79.3564Z",
    fill: "#00B4D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5415 84.0234H61.3828V85.7644H84.5415V84.0234Z",
    fill: "#00B4D8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.882 93.3423H69.707V95.0832H103.882V93.3423Z",
    fill: "#00B4D8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.882 98.0093H61.3828V99.7502H103.882V98.0093Z",
    fill: "#00B4D8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.882 102.676H61.3828V104.417H103.882V102.676Z",
    fill: "#00B4D8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.882 107.328H61.3828V109.069H103.882V107.328Z",
    fill: "#00B4D8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5415 111.352H61.3828V113.092H84.5415V111.352Z",
    fill: "#00B4D8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.975 60.0772L124.88 52.7591L124.854 52.7416L125.75 51.6171L125.793 51.6496L127.109 52.6805L130.877 55.6315L129.974 56.7436L126.206 53.7927L120.298 61.1204L118.975 60.0772Z",
    fill: "#03045E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M118.975 60.0772L124.88 52.7591L124.854 52.7416L125.75 51.6171L125.793 51.6496L127.109 52.6805L130.877 55.6315L129.974 56.7436L126.206 53.7927L120.298 61.1204L118.975 60.0772Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114.48 83.643C123.939 76.7964 130.671 68.456 134.675 58.6218L129.546 54.6171C120.917 61.2299 113.993 69.8084 109.351 79.6383L114.48 83.643Z",
    fill: "#03045E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.358 107.349L89.5652 110.936L87.0005 112.519L90.2284 103.345L95.358 107.349Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4151 111.03L87.7471 112.059L87.0003 112.519L87.9369 109.872L89.4151 111.03Z",
    fill: "#03045E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3581 107.35L114.481 83.6433L109.361 79.6412L90.2285 103.345L95.3581 107.35Z",
    fill: "#03045E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M95.3581 107.35L114.481 83.6433L109.361 79.6412L90.2285 103.345L95.3581 107.35Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M134.675 58.6221L129.546 54.6174C129.546 54.6174 130.651 52.7209 133.348 54.6968C136.044 56.6727 134.675 58.6221 134.675 58.6221Z",
    fill: "#03045E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M134.675 58.6221L129.546 54.6174C129.546 54.6174 130.651 52.7209 133.348 54.6968C136.044 56.6727 134.675 58.6221 134.675 58.6221Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySubmissionNotes);
export default __webpack_public_path__ + "static/media/Empty_Submission_Notes.dafa890b59bdb58b22909e24915d9947.svg";
export { ForwardRef as ReactComponent };